import React, { useEffect, useState } from "react";
import { FaTrash, FaEdit, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "../Control-panel.css"; // Asegúrate de tener este archivo CSS para los estilos

const ControlPlans = () => {
  const [messageModal, setMessageModal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [listPlans, setListPlans] = useState([]);

  const [plan, setNamePlan] = useState("");
  const [insumos, setInsumos] = useState("");
  const [kilos, setKilos] = useState("");
  const [precio_plan, setPrecioPlan] = useState(0);

  const [toggleFormPlan, setToggleFormPlan] = useState(false);

  const [editingPlan, setEditingPlan] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);

  const [emptyData, setEmptyData] = useState(false);

  const typeMessages = {
    create: "¡Plan registrado exitosamente!",
    update: "¡Datos del plan actualizados exitosamente!",
    delete: "Plan eliminado exitosamente!",
    error: "Error en el mensaje del modal",
  };

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getPlans();
  }, []);

  const openModalSuccess = (type) => {
    switch (type) {
      case "create":
        setMessageModal(typeMessages.create);
        break;
      case "update":
        setMessageModal(typeMessages.update);
        break;
      case "delete":
        setMessageModal(typeMessages.delete);
        break;
      default:
        setMessageModal(typeMessages.error);
        break;
    }
    setIsModalOpen(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };

  const cleanFormPlans = () => {
    setNamePlan("");
    setInsumos("");
    setKilos("");
    setPrecioPlan(0);
  };

  const getPlans = () => {
    fetch(`${API_URL}/plans`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          setListPlans(result.result);
          console.log("planes ", result.result);
        } else {
          console.log("No se pudo consultar los planes");
        }
      });
  };
  const addPlan = () => {
    const data = { plan, insumos, kilos, precio_plan };

    if (!plan || !insumos || !kilos || !precio_plan) {
      setEmptyData(true);
      setTimeout(() => {
        setEmptyData(false);
      }, 3000);
      return;
    }

    fetch(`${API_URL}/create-plan`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          openModalSuccess("create");
          getPlans();
          setToggleFormPlan(false);
          cleanFormPlans();
        } else {
          alert("No se pudo registrar el nuevo plan");
        }
      })
      .catch(() => {
        console.log("ERROR CACTH");
      });
  };
  const deletePlan = (planName) => {
    fetch(`${API_URL}/plan-delete/${planName}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          openModalSuccess("delete");
          setListPlans(listPlans.filter((plan) => plan.plan !== planName)); // Elimina visualmente el plan
        } else {
          alert("Error al eliminar el plan.");
        }
      })
      .catch((error) => console.error("Error al eliminar el plan:", error));
  };

  const updatePlan = () => {
    if (!isUpdating) return;

    const formattedData = {
      ...updatedData,
      kilos: `0 - ${updatedData.kilos}`,
    };

    fetch(`${API_URL}/update-plan/${editingPlan}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formattedData),
    })
      .then((response) => response.json())
      .then(() => {
        getPlans();
        setEditingPlan(null);
        setIsUpdating(false);
        openModalSuccess("update");
      })
      .catch((error) => console.error("Error al actualizar el plan:", error));
  };

  const enableEditing = (plan) => {
    setEditingPlan(plan.plan);
    setUpdatedData({
      newPlan: plan.plan,
      kilos: 0,
      insumos: plan.insumos,
      precio_plan: plan.precio_plan,
    });
    setIsUpdating(true);
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;

    setUpdatedData((prev) => {
      const newData = {
        ...prev,
        [field]: value,
      };

      const allFieldsFilled = Object.values(newData).every(
        (val) => String(val || "").trim() !== ""
      );
      setIsUpdating(allFieldsFilled);

      return newData;
    });
  };

  return (
    <div className="container-control-module">
      <div className="table-container">
        <h2>Consulta de planes</h2>
        <table>
          <thead>
            <tr>
              <th>Plan</th>
              <th>Insumos</th>
              <th>Kilos</th>
              <th>Precio</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {listPlans.map((plan) => {
              return (
                <tr key={plan.plan}>
                  <td>
                    {editingPlan === plan.plan ? (
                      <input
                        type="text"
                        value={updatedData.newPlan}
                        onChange={(e) => handleInputChange(e, "newPlan")}
                      />
                    ) : (
                      plan.plan
                    )}
                  </td>
                  <td>
                    {editingPlan === plan.plan ? (
                      <input
                        type="text"
                        value={updatedData.insumos}
                        onChange={(e) => handleInputChange(e, "insumos")}
                      />
                    ) : (
                      plan.insumos
                    )}
                  </td>
                  <td>
                    {editingPlan === plan.plan ? (
                      <input
                        type="number"
                        value={updatedData.kilos}
                        onChange={(e) => handleInputChange(e, "kilos")}
                      />
                    ) : (
                      plan.kilos
                    )}
                  </td>
                  <td>
                    {editingPlan === plan.plan ? (
                      <input
                        type="number"
                        value={updatedData.precio_plan}
                        onChange={(e) => handleInputChange(e, "precio_plan")}
                      />
                    ) : (
                      plan.precio_plan
                    )}
                  </td>
                  <td>
                    <FaEdit
                      className="edit-icon"
                      onClick={() => enableEditing(plan)}
                    />
                    <FaTrash
                      className="delete-icon"
                      onClick={() => deletePlan(plan.plan)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Formulario */}
      <div className="container-buttons-table">
        <button
          className="btn-add-control-panel"
          onClick={() => setToggleFormPlan(true)}
        >
          + Registrar nuevo plan
        </button>
        {isUpdating && (
          <button
            className="btn-add-control-panel"
            onClick={updatePlan}
            disabled={!isUpdating}
          >
            Actualizar
          </button>
        )}
      </div>
      {toggleFormPlan && (
        <div className="form-container mb-5">
          <h2>Gestión de planes</h2>
          <div className="form-group">
            <label htmlFor="name-plan">Nombre del plan*</label>
            <input
              type="text"
              id="name-plan"
              value={plan}
              placeholder="Escribe el nombre del plan"
              onChange={(e) => {
                setNamePlan(e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="insumos-plan">Insumos del plan*</label>
            <input
              type="text"
              id="insumos-plan"
              value={insumos}
              placeholder="Escribe los insumos que incluye el plan"
              onChange={(e) => {
                setInsumos(e.target.value);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="kilos">Máximo de kilos permitidos*</label>
            <input
              type="number"
              id="kilos"
              placeholder="Escribe el numero de kilos máximo permitido"
              onChange={(e) => {
                setKilos(`0 - ${e.target.value.toString()}`);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="precio">Precio del plan*</label>
            <input
              type="number"
              id="precio"
              value={precio_plan}
              placeholder="Escribe el precio"
              onChange={(e) => {
                setPrecioPlan(e.target.value);
              }}
            />
          </div>
          <div className="add-container">
            <button
              className="btn-add-control-panel mb-4"
              onClick={() => addPlan()}
            >
              Crear plan
            </button>
          </div>
        </div>
      )}
      {/* Modal de éxito */}
      {isModalOpen && (
        <div className="modal-success">
          <div className="modal-content">
            <FaCheckCircle size={100} color="green" className="modal-icon" />
            <h1>{messageModal}</h1>
          </div>
        </div>
      )}
      {emptyData && (
        <div className="modal-success">
          <div className="modal-content">
            <FaTimesCircle size={100} color="red" className="modal-icon" />
            <h1>Por favor llenar todos los campos obligatorios(*)</h1>
          </div>
        </div>
      )}
    </div>
  );
};

export default ControlPlans;
